// ─────────────────────────────────────────────────────────────────────────────
// NOTION DESIGN TOKENS — the shared look for this board's tool surfaces.
//
// Same values Hank uses on the Air Duct board (airduct/notion.ts). Copied
// rather than imported on purpose: one owner per board directory, so a change
// on his side can never move this board mid-review. If these two ever need to
// diverge, that is a bug — they are the same design language.
//
// What actually makes something read as Notion, in order of importance:
//   1. WARM INK, not black. #37352F. Near-black reads as a generic app.
//   2. 3px radii. Notion is barely rounded.
//   3. HAIRLINE borders and NO shadows. Separation is a 1px line, not elevation.
//   4. Tinted callouts — a soft background block, no left bar.
//   5. Air. Generous line-height, left aligned, minimal chrome.
// ─────────────────────────────────────────────────────────────────────────────

export const N = {
  ink: "#37352F",
  ink2: "#787774",
  ink3: "#9B9A97",
  bg: "#FFFFFF",
  bgGray: "#F7F6F3",
  bgHover: "#EFEFEE",
  line: "#E9E9E7",
  lineSoft: "rgba(55, 53, 47, 0.09)",
  lineStrong: "rgba(55, 53, 47, 0.16)",
  red: "#E03E3E", redBg: "#FBECEB",
  orange: "#D9730D", orangeBg: "#FAEBDD",
  yellow: "#CB912F", yellowBg: "#FBF3DB",
  green: "#0F7B6C", greenBg: "#EDF3EC",
  blue: "#0B6E99", blueBg: "#E7F3F8",
  purple: "#6940A5", purpleBg: "#F6F3F9",
  gray: "#787774", grayBg: "#F1F1EF",
} as const;

export const NFONT =
  'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif';

export const NMONO =
  '"SFMono-Regular", Menlo, Consolas, "PT Mono", "Liberation Mono", Courier, monospace';

export const R = 3;
export const R_CTL = 4;
